/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const thirdPartyEnumsIncidentAffectsACustomerOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    CannotSpecify: 'CannotSpecify',
} as const;

export type ThirdPartyEnumsIncidentAffectsACustomerOptionEnumKey =
    (typeof thirdPartyEnumsIncidentAffectsACustomerOptionEnum)[keyof typeof thirdPartyEnumsIncidentAffectsACustomerOptionEnum];

export type ThirdPartyEnumsIncidentAffectsACustomerOption = ThirdPartyEnumsIncidentAffectsACustomerOptionEnumKey;
